<header class="header">
  <div class="header__left">
    <img
      src="assets/img/logo-small.svg"
      alt="Logo"
      class="header__left-image" />
    <h2
      *ngIf="headerTitle"
      class="header__left-title">
      {{ "TITLE." + headerTitle | translate }}
    </h2>
  </div>
  <div class="header__right">
    <div class="header__right-lang">
      <div
        [class.active]="isActive"
        (click)="isActive = false"
        class="bg"></div>
      <div
        [class.active]="isActive"
        (click)="isActive = !isActive"
        class="lang-select">
        <img
          src="assets/img/lang-icon.svg"
          alt="Lang icon"
          class="lang-select__icon" />
        <p class="lang-select__current">[ {{ codeLang }} ]</p>
        <ul class="lang-select__list">
          <li
            (click)="changeLang('ru')"
            class="lang-select__list-item">
            <img
              *ngIf="codeLang !== 'RU'"
              src="assets/img/lang-icon.svg"
              alt="Icon"
              class="icon" />
            <img
              *ngIf="codeLang === 'RU'"
              src="assets/img/check-lang.svg"
              alt="Icon"
              class="icon" />
            {{ "LANG.RU" | translate }}
          </li>
          <li
            (click)="changeLang('kk')"
            class="lang-select__list-item">
            <img
              *ngIf="codeLang !== 'KK'"
              src="assets/img/lang-icon.svg"
              alt="Icon"
              class="icon" />
            <img
              *ngIf="codeLang === 'KK'"
              src="assets/img/check-lang.svg"
              alt="Icon"
              class="icon" />
            {{ "LANG.KK" | translate }}
          </li>
        </ul>
      </div>
    </div>

    <button
      (click)="logout()"
      class="exit-btn">
      <img
        src="assets/img/exit-icon.svg"
        alt="Logo"
        class="exit-btn__image" />
    </button>

    <button
      (click)="openMobileMenu()"
      class="header__right-menu">
      <img
        src="assets/img/menu-icon.svg"
        alt="Menu"
        class="icon" />
    </button>
  </div>
</header>
